import { render, staticRenderFns } from "./MonitorChapterCreate.vue?vue&type=template&id=415bfd60&"
import script from "./MonitorChapterCreate.vue?vue&type=script&lang=js&"
export * from "./MonitorChapterCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports